var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DeleteButton',{attrs:{"size":"large","disabled":_vm.disabled},on:{"click":_vm.confirmDeleteRelease}})
}
var staticRenderFns = []

export { render, staticRenderFns }